import { useContext } from 'react';
import type { Span } from '@repo/shared';

import { TraceContext } from '@/routes/(app)/(tracing)/context/trace-context';

export function useOpenTrace() {
  const {
    setTrace,
    isOpen: open,
    setIsOpen: setOpen,
    trace: currentTrace,
    setSpan,
    setOpenDetail,
    setCurrentTraceIndex,
  } = useContext(TraceContext);

  const openTrace = (trace: Array<Span>, traceIndex: number) => {
    setTrace(trace);
    const parentSpan =
      trace.find((span) => span.parentSpanId === null) ?? trace[0];
    if (parentSpan) {
      setSpan(parentSpan);
    }
    setCurrentTraceIndex(traceIndex);
    if (open && currentTrace?.[0]?.id !== trace[0]?.id) return;
    setOpen((prev) => !prev);
    setOpenDetail((prev) => !prev);
  };

  return { openTrace };
}
